import React from 'react';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import ModalRoot, { Modal, ModalHeader } from '../../../../components/Modal';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { CARD_ENABLE } from '../../mutations';
import { showAlert } from '../../../../utilities/notifications';
import { useCardStatus } from '../../../../utilities/sharedHooks/user';
import { dynamicAssets } from '../../../../utilities/helpers';

const EnableCardModal = ({ hide }) => {
  const { t: translate } = useTranslation();
  const { refetch: getCardStatus } = useCardStatus({
    enabled: false,
  });

  const { mutate: enableCard } = useMutation(CARD_ENABLE, {
    onSettled: (data, error) => {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else if (data) {
        getCardStatus();
        hide();
      }
    },
  });

  const renderFooter = () => (
    <div className="d-flex flex-row justify-content-around" style={{ marginTop: 'auto' }}>
      <button
        onClick={hide}
        className="btn border-grey border text-f5 mt-4 w-50 me-2"
        type="button">
        {translate('enable_card_secondary_btn')}
      </button>
      <button onClick={enableCard} className="btn btn-primary  text-f5 mt-4 w-50" type="button">
        {translate('enable_card_primary_btn')}
      </button>
    </div>
  );
  return (
    <ModalRoot>
      <Modal
        contentStyle={
          isBrowser
            ? {
                maxHeight: '45rem',
                position: 'fixed',
              }
            : {}
        }>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBodyLayout renderFooter={renderFooter}>
          <img
            style={{
              width: '100%',
              height: 'auto',
              resize: 'contain',
              alignSelf: 'center',
            }}
            src={dynamicAssets('./assets/images/reportVisacard.svg')}
            alt="masterCardSecurity"
          />
          <div className="text-f5 flex-column d-flex align-items-center">
            <p>{translate('enable_card_title')}</p>
            <p className="text-shadow mt-2 mb-4">{translate('enable_card_subtitle')}</p>
          </div>

          <div className="alert alert-info d-flex mt-5">
            <i className="icon icon-info-icon" />
            <div className="content">{translate('enable_card_info_box')}</div>
          </div>
        </ModalBodyLayout>
      </Modal>
    </ModalRoot>
  );
};
EnableCardModal.propTypes = {
  hide: PropTypes.func.isRequired,
};
export default EnableCardModal;
